import { INTERNAL_CUSTOMER_EXCLUDED_BRANCH_IDS, WM_BRANCH_IDS } from "./branchIds"

export const CUSTOMER_FILTER_GROUP_PREDICATE = `key in ("adm_user", "adm_regionallead", "adm_admin", "idm_user", "idm_disponent", "idm_lead", "idm_theke", "idm_procurement", "adm_gvl")`
export const CUSTOMER_FILTER_BRANCH_PREDICATE = `key in ("branch-00", "branch-06", "branch-07", "branch-08", "branch-26", "branch-36", "branch-66", "branch-76", "branch-86")`
export const INTERNAL_CUSTOMER_FILTER_BRANCH_PREDICATE = `key in ("branch-06", "branch-26", "branch-36")`

const excludedWmBranchIds = WM_BRANCH_IDS.map((id) => `"${id}"`).join(", ")
export const CUSTOMER_FILTER_CUSTOMER_BRANCH_PREDICATE = `customerBranch not in (${excludedWmBranchIds})`

const excludedBranchIds = INTERNAL_CUSTOMER_EXCLUDED_BRANCH_IDS.map((id) => `"${id}"`).join(", ")
export const INTERNAL_CUSTOMER_FILTER_CUSTOMER_BRANCH_PREDICATE = `customerBranch not in (${excludedBranchIds})`
